import { useEffect, useState } from 'react';
import { API_BASE_URL, API_GRAPHQL } from '../../constants';

export function useSpecificProductApi(id) {
  const url = `${API_BASE_URL}/products/${id}?populate=*`;
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [sameCategoryProducts, setSameCategoryProducts] = useState([]);

  useEffect(() => {
    async function getProduct(url) {
      try {
        setIsLoading(true);
        setIsError(false);

        const response = await fetch(url);
        const json = await response.json();
        console.log('populated', json);
        setProduct(json);
        const categoryID = json.data.attributes.category.data.id;
        
        const supplierId = json.data.attributes.supplier.data.id;
        //const relatedUrl = `${API_BASE_URL}/suppliers/${supplierId}?populate=*`
        const relatedResponse = await fetch(API_GRAPHQL, {
          method: 'POST',
          headers: {'Content-Type' : 'application/json'},
          body: JSON.stringify({
            query: `{
              category(id: ${categoryID}){
                data{
                  id
                  attributes{
                    place
                    products{
                      data{
                        id
                        attributes{
                          name
                          visible
                          varenummer
                          image{
                            data{
                              id
                              attributes{
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              supplier(id: ${supplierId})
              {
                data{
                  id
                  attributes{
                    name
                    products{
                      data{
                        id
                        attributes{
                          name
                          image{
                            data{
                              attributes{
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`
          })
        });
        const relatedJson = await relatedResponse.json();
        setRelatedProducts(relatedJson);
        setSameCategoryProducts(relatedJson.data.category.data.attributes.products.data.slice(0,5));
        //console.log('same category array', sameCategoryProducts);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    }

    getProduct(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return { product, sameCategoryProducts, isLoading, isError, relatedProducts };
}